import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useBasicButtonStyles = makeStyles({
  root: {
    fontWeight: tokens.fontWeightSemibold,
    fontSize: fontScale.body,
  },
  fullWidth: {
    width: '100%',
    minWidth: 0,
  },
  /**
   * Figma-aligned primary look: brand fill, on-brand text, 2 px corner radius. Opt-in only.
   */
  figmaPrimary: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    ...shorthands.borderRadius('0.125rem'),
    ...shorthands.borderColor(tokens.colorBrandBackground),
    fontWeight: tokens.fontWeightSemibold,
    ':hover': {
      backgroundColor: tokens.colorBrandBackground,
      color: tokens.colorNeutralForegroundOnBrand,
      opacity: 0.9,
    },
    ':hover:active': {
      backgroundColor: tokens.colorBrandBackground,
      color: tokens.colorNeutralForegroundOnBrand,
      opacity: 0.85,
    },
    ':disabled, :disabled:hover': {
      opacity: 0.5,
    },
  },
  /**
   * Figma-aligned secondary look: transparent fill, brand text + 1 px brand border,
   * 2 px corner radius. Opt-in only.
   */
  figmaSecondary: {
    backgroundColor: 'transparent',
    color: tokens.colorBrandStroke1,
    ...shorthands.border('1px', 'solid', tokens.colorBrandStroke1),
    ...shorthands.borderRadius('0.125rem'),
    fontWeight: tokens.fontWeightSemibold,
    ':hover': {
      backgroundColor: tokens.colorSubtleBackgroundHover,
      color: tokens.colorBrandStroke1,
      ...shorthands.borderColor(tokens.colorBrandStroke1),
    },
    ':hover:active': {
      backgroundColor: tokens.colorSubtleBackgroundHover,
      opacity: 0.9,
    },
  },
});
